























































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';
import XLSX from 'xlsx';
import numeral from 'numeral';


@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'items',
    ]),
    ...mapGetters(STORE_KEY, [
      'totalData'
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX'
    ])
  },
  components: {
    TitleBar
  }
})
export default class TransportExpencesReport extends Vue {

  get titleStack () {
    return [
      'Отчеты',
      'По фактическим затратам'
    ]
  }
  numeral = numeral

  localFilter = {
    targetDates: [new Date(), new Date()],
    month: new Date(),
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'client_name', this.$route.query.sortDirection || 'asc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.month = (this.$route.query && this.$route.query.month) ? moment(this.$route.query.month).toDate() : new Date();

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      switch (key) {
        case 'targetDates':
          //@ts-ignore
          ac[key] = [moment(this.localFilter[key][0]).format('YYYY-MM-DD'), moment(this.localFilter[key][1]).format('YYYY-MM-DD')]
          break;

        case 'month':
          //@ts-ignore
          ac[key] = moment(this.localFilter[key]).format('YYYY-MM-DD');
          break;

        default:
          // @ts-ignore
          ac[key] = this.localFilter[key]
      }
      return ac;
    }, {});
      console.log(query);

    this.$router.replace({
      query
    })
  }

  tableToExcel() {
    const csvContent: any[] = [];
    const cols_props_10: any = {wch: 10, hpt: 15};
    const cols_props_25: any = {wch: 25, hpt: 15};

    csvContent.push(...this.$store.getters[`${STORE_KEY}/exportData`]);
    const ws = XLSX.utils.aoa_to_sheet(csvContent);
    ws["!cols"] = [
        cols_props_25, cols_props_10, cols_props_10, cols_props_10, cols_props_10, cols_props_10, cols_props_10
      ];
    // @ts-ignore
    const range = XLSX.utils.decode_range(ws['!ref']);
    for(let R = range.s.r; R <= range.e.r; ++R) {

      for(let C = range.s.c; C <= range.e.c; ++C) {
        const cellref = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
        if(!ws[cellref] || C < 1 || R < 1) continue; // if cell doesn't exist, move on
        const cell = ws[cellref];
        cell.t = 'n'
        cell.z = '0.00'
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Отчет");
    XLSX.writeFile(wb, 'export.xlsx')
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
